import { render, staticRenderFns } from "./WorkflowFormulateMulti.vue?vue&type=template&id=522bd5ec"
import script from "./WorkflowFormulateMulti.vue?vue&type=script&lang=js"
export * from "./WorkflowFormulateMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports